import { canArchiveInvoice } from '../features/NewInvoicesSlice'

export const BULK_SELECTION_MODE = {
  PAGE: 'page',
  ALL_FILTERED: 'all_filtered',
}

export const getBulkArchivableInvoices = invoices =>
  (Array.isArray(invoices) ? invoices : []).filter(canArchiveInvoice)

export const getBulkArchiveInvoiceIds = (
  invoices,
  { mode = BULK_SELECTION_MODE.PAGE, pageSelectedKeys = [] } = {},
) => {
  if (mode === BULK_SELECTION_MODE.ALL_FILTERED) {
    return getBulkArchivableInvoices(invoices).map(invoice => invoice.id)
  }

  const selectedKeys = new Set(
    (Array.isArray(pageSelectedKeys) ? pageSelectedKeys : []).map(String),
  )

  return getBulkArchivableInvoices(invoices)
    .filter(invoice => selectedKeys.has(String(invoice.id)))
    .map(invoice => invoice.id)
}

export const getBulkDeletableInvoices = invoices =>
  (Array.isArray(invoices) ? invoices : []).filter(invoice => invoice?.id)

export const getBulkDeleteInvoiceIds = (
  invoices,
  { mode = BULK_SELECTION_MODE.PAGE, pageSelectedKeys = [] } = {},
) => {
  if (mode === BULK_SELECTION_MODE.ALL_FILTERED) {
    return getBulkDeletableInvoices(invoices).map(invoice => invoice.id)
  }

  const selectedKeys = new Set(
    (Array.isArray(pageSelectedKeys) ? pageSelectedKeys : []).map(String),
  )

  return getBulkDeletableInvoices(invoices)
    .filter(invoice => selectedKeys.has(String(invoice.id)))
    .map(invoice => invoice.id)
}

export const buildBulkActionFailureRows = (
  results = [],
  invoices = [],
  { defaultMessage = 'Action could not be completed' } = {},
) => {
  const invoiceById = new Map(
    (Array.isArray(invoices) ? invoices : []).map(invoice => [
      String(invoice.id),
      invoice,
    ]),
  )

  return (Array.isArray(results) ? results : [])
    .filter(result => !result?.success)
    .map(result => {
      const invoice = invoiceById.get(String(result.invoiceId))
      return {
        key: result.invoiceId,
        invoiceId: result.invoiceId,
        supplierTitle: invoice?.supplierTitle || '—',
        invoiceNumber:
          invoice?.invoiceNumber || invoice?.purchaseOrderNumber || '—',
        message: result.message || defaultMessage,
      }
    })
}

export const buildBulkArchiveFailureRows = (results = [], invoices = []) =>
  buildBulkActionFailureRows(results, invoices, {
    defaultMessage: 'Could not be archived',
  })

export const buildBulkDeleteFailureRows = (results = [], invoices = []) =>
  buildBulkActionFailureRows(results, invoices, {
    defaultMessage: 'Could not be deleted',
  })

export const shouldShowSelectAllFilteredPrompt = ({
  bulkSelectAllFiltered,
  selectedRowKeys,
  selectableFilteredCount,
  archivableFilteredCount,
}) => {
  const filteredCount = selectableFilteredCount ?? archivableFilteredCount ?? 0

  return (
    !bulkSelectAllFiltered &&
    selectedRowKeys.length > 0 &&
    filteredCount > selectedRowKeys.length
  )
}
